import { Component, Prop, Vue } from 'vue-property-decorator';
import { CodeDTO } from '@/models/CodeDTO';
import { CodeTranslationDTO } from '@/models/CodeTranslationDTO';
import InputCheckbox from '../InputCheckbox/InputCheckbox';

@Component({
  components: {
    InputCheckbox,
  },
})
export default class CheckboxList extends Vue {
  @Prop() public values!: CodeDTO[];
  @Prop({default: []}) public checked!: number[];

  private innerChecked: number[] = [];

  public get lngId() {
    switch (this.$i18n.locale) {
        case 'de':
            return 1;
        case 'en':
            return 2;
        case 'fr':
            return 3;
        case 'it':
            return 4;
        default:
            return 1;
    }
  }

  protected mounted(): void {
    this.innerChecked = this.checked;
  }

  protected getTranslation(code: CodeDTO): string {
    const translation = code.translations.find((x: CodeTranslationDTO) => x.lngId === this.lngId);
    return translation === undefined ? code.codName : translation.caption;
  }

  protected checkChanged(value: CodeDTO, checked: boolean) {
    if (checked && this.innerChecked.indexOf(value.codId) === -1) {
      this.innerChecked.push(value.codId);
      this.$emit('checkChanged', this.innerChecked);
    }

    if (!checked && this.innerChecked.indexOf(value.codId) !== -1) {
      const index = this.innerChecked.indexOf(value.codId, 0);
      if (index > -1) {
        this.innerChecked.splice(index, 1);
      }
      this.$emit('checkChanged', this.innerChecked);
    }
  }
}
